import { Row, Col } from "../../App.styles";

const RewardsSection = ({ useQuery }) => {
  const { reward_title, reward_description, reward_thumb } = useQuery();

  return (
    <Row>
      <Col>
        <p>
          Title: {reward_title}
          <br />
          Description: {reward_description}
          <br />
          Image: <img src={reward_thumb} alt={reward_title} />
        </p>
      </Col>
    </Row>
  );
};

export default RewardsSection;
